import React, { Fragment, useEffect, useState } from "react";
import { Card, Table } from "reactstrap";
import { useParams } from "react-router-dom";
import { P, H5 } from "../../../AbstractElements";
import useAxios from "../../../Utils/useAxios";
import { getStatusData, STATUS_DATA_TYPE } from "../../../Constant/StatusData";
import { getStatusBadge } from "../../../Utils/otherFunctions";
import {
  dateTimeFieldToDate,
  formatRP,
} from "../../../Utils/externalFunctions";
import RenderContentMail from "./RenderContentMail";

const MailContain = () => {
  const axiosInstance = useAxios();
  const { module, moduleId } = useParams();
  const [mail, setMail] = useState(null);

  useEffect(() => {
    if (module && moduleId) {
      getMail();
    }
  }, [module, moduleId]);

  const getMail = async () => {
    const moduleUrls = {
      Transaksi: `transaksi/${moduleId}`,
      Realokasi: `realokasi/${moduleId}`,
      UMK: `umk/${moduleId}`,
      UMO: `umo/${moduleId}`,
    };

    const url = moduleUrls[module];
    if (url) {
      try {
        const res = await axiosInstance.get(url);
        if (res.status === 200) {
          setMail(res.data);
        }
      } catch (error) {
        console.error("Error fetching mail:", error);
      }
    }
  };

  return (
    <Fragment>
      <div className="email-right-aside">
        <Card className="email-body">
          <div className="email-profile">
            <div className="email-right-aside">
              <div className="email-body">
                <div className="email-content">
                  <div className="email-wrapper">
                    <RenderContentMail mail={mail} module={module} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </Fragment>
  );
};

export default MailContain;
